import { render, staticRenderFns } from "./ProductSwatches.vue?vue&type=template&id=e2023f7e"
import script from "./ProductSwatches.vue?vue&type=script&lang=js"
export * from "./ProductSwatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports